import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

const Logo = ({ p, idx }) => {
  const [failed, setFailed] = useState(!p.logo);
  return (
    <a href={p.url || "/partners"} target="_blank" rel="noreferrer" title={p.name} aria-label={p.name}
      className="flex h-24 w-56 shrink-0 items-center justify-center partner-logo-card rounded-2xl px-4 shadow-sm transition-transform duration-300 hover:-translate-y-0.5"
      data-testid={`partners-bar-logo-${p.id}-${idx}`}>
      {failed ? <span className="partner-logo-name font-display text-lg font-black">{p.name}</span>
        : <img src={p.logo} alt={p.name} className="h-16 w-full object-contain" onError={() => setFailed(true)} />}
    </a>
  );
};

export const PartnersBar = () => {
  const { t } = useLang();
  const { data } = useFetch("/public/partners");
  if (!data?.length) return null;
  const loop = Array.from({ length: Math.max(2, Math.ceil(12 / data.length)) * 2 }, () => data).flat();
  return (
    <section className="bg-[#FF5722] py-10 text-white" data-testid="home-partners-bar">
      <div className="container-x mb-6 flex items-end justify-between">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-white" data-testid="partners-bar-title">{t("partners_title")}</p>
        <Link to="/partners" className="text-sm font-semibold text-white hover:underline" data-testid="partners-bar-all">Partnership →</Link>
      </div>
      <div className="partners-marquee group relative overflow-hidden">
        <div className="partners-track flex w-max gap-6 group-hover:[animation-play-state:paused]" style={{ animationDuration: `${loop.length * 3}s` }}>
          {loop.map((p, i) => <Logo key={`${p.id}-${i}`} p={p} idx={i} />)}
        </div>
      </div>
    </section>
  );
};
